module.exports = __webpack_public_path__ + "298c66d3036013a5084268c941157691.svg";